import { DateTime } from 'luxon';
import { Mod } from '../model/tag';
import { Template } from '../model/template';

export const folderTemplate: Template = {
  tag: 'folder',
  name: $localize`📂️ Folder`,
  config: {
    type: 'lens',
    experimental: true,
    generated: $localize`Generated by jasper-ui ${DateTime.now().toISO()}`,
    submit: $localize`📂️ folder/`,
    view: $localize`📂️`,
    writeAccess: ['+folder'],
    local: true,
    description: $localize`Activates built-in Folder mode for viewing Refs.`,
    filters: [
      { query: 'folder', label: $localize`📂️ folder`, title: $localize`Folders`, group: $localize`Templates 🎨️` },
    ],
  },
  defaults: {
    files: {},
    subfolders: {},
  },
  schema: {
    definitions: {
      Pos: {
        optionalProperties: {
          x: { type: 'uint32' },
          y: { type: 'uint32' }
        }
      }
    },
    optionalProperties: {
      flatten: { type: 'boolean' },
    },
    properties: {
      files: { values: { ref: 'Pos' }},
      subfolders: { values: { ref: 'Pos' }},
    },
  },
};

export interface Pos {
  x: number;
  y: number;
}

export const folderMod: Mod = {
  template: [
    folderTemplate,
  ]
};
